module.exports = __webpack_public_path__ + "img/MRK.1e61bc15.png";